import { Component } from "react";
import { logFrontendError } from "utils/errorLogger";

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logFrontendError({
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
      source: "render",
      severity: "fatal",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          height: "100%", minHeight: "100vh", gap: 16, padding: "2rem",
          textAlign: "center",
        }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="#dd4498" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <p style={{ fontSize: 16, color: "#555", margin: 0 }}>
            Something went wrong.<br />
            Please reload the page and try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#dd4498", color: "#fff", border: "none",
              borderRadius: 8, padding: "10px 28px", fontSize: 15,
              fontWeight: 600, cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
